const dialogContent = {
    saved: "Data saved successfully.",
    updated: "Data updated successfully.",
    modified: "Record(s) not Saved/Updated. Do you want to continue?",
    deleted: "Record deleted successfully.",
    confirmDelete: "Are you sure you want to delete?",
    confirmSave: "Are you sure you want to save?",
    reset: "Data save successfully and a change password link has been sent to User Email address.",
    unblockuser: "Are you sure you want to unblock the user?",
    unblockdelete: "User is unblocked successfully. New password is Welcome@123",
    confirmReset: "Are you sure you want to reset the password? (Welcome@123)",
}

const statusName = [
    { statusvalue: 1, statuslabel: "Open" },
    { statusvalue: 2, statuslabel: "In Progress" },
    { statusvalue: 3, statuslabel: "Cancelled" },
];

const statusList = {
    open: { id: 1, label: "Open" },
    scheduled: { id: 2, label: "Scheduled" },
    inProgress: { id: 3, label: "In Progress" },
    completed: { id: 4, label: "Completed" },
    closed: { id: 5, label: "Closed" },
    cancelled: { id: 6, label: "Cancelled" },
    notDoneAndClosed: { id: 7, label: "Not Done and Closed" },
    verified: { id: 8, label: "Verified" },
    completedOutsource: { id: 9, label: "Completed-Outsource" },
    inProgressOutsource: { id: 10, label: "In Progress-Outsource" }
};

const processingPercentageValue = {
    basicDetails: 16,
    assessmentTab: 32,
    workOrderAttachments: 48,
    partReplacement: 68,
    completionInfo: 88,
    costInfo: 92,
    summaryAndAuthorization: 100
};

const workrequest = {
    statusvalue: 1,
    statuslabel: "Open"
}
const validations = [
    { regex: /^\s/, message: 'Space not allowed at the beginning' },
    { regex: /\s\s/, message: 'Double Space not allowed' },
    { regex: /[^a-zA-Z0-9 ,!@#$%&*()_-]/, message: 'Invalid characters in Class/Grade.' },
];

const workTypeOptions = [
    { label: "Civil", value: "Civil", id: 1 },
    { label: "Mechanical", value: "Mechanical", id: 2 },
    { label: "Electrical", value: "Electrical", id: 3 },
    { label: "Biomedical", value: "Biomedical", id: 4 },
];

const active = {
    label: "Active",
    value: "Active",
    id: true,
    fieldID: 1
};

const inActive = {
    label: "Inactive",
    value: "Inactive",
    id: false,
    fieldID: 2
};


export {
    dialogContent,
    validations,
    statusName,
    workrequest,
    statusList,
    processingPercentageValue,
    workTypeOptions,
    active,
    inActive

}
